(() => {
  'use strict';
  const controllers = new WeakMap();
  function init(scope) {
    const roots = [...scope.querySelectorAll('[data-mr-interview]')];
    if (scope.matches?.('[data-mr-interview]')) roots.unshift(scope);
    roots.forEach(root => {
      if (controllers.has(root)) return;
      const dialog = root.querySelector('.sp-photo-viewer');
      if (!dialog || !dialog.showModal) return;
      const events = new AbortController(), options = {signal: events.signal};
      const image = dialog.querySelector('img'), caption = dialog.querySelector('figcaption');
      const count = dialog.querySelector('.sp-viewer-count'), close = dialog.querySelector('[data-viewer-close]');
      const previous = dialog.querySelector('[data-viewer-prev]'), next = dialog.querySelector('[data-viewer-next]');
      let photos = [], index = 0, restoreFocus = null, previousOverflow = '';
      function show(nextIndex) {
        index = Math.max(0, Math.min(photos.length - 1, nextIndex));
        const link = photos[index], thumbnail = link.querySelector('img');
        const backup = thumbnail?.getAttribute('data-mr-image-backup') || '';
        image.src = thumbnail?.dataset.mrBackupUsed ? thumbnail.src : link.href;
        image.alt = thumbnail?.alt || '';
        image.dataset.mrImageBackup = backup;
        delete image.dataset.mrBackupUsed;
        caption.textContent = link.closest('.sp-gallery-slide')?.dataset.caption || link.closest('figure')?.querySelector('figcaption')?.textContent.trim() || '';
        count.textContent = (index + 1) + ' / ' + photos.length;
        previous.disabled = index === 0;
        next.disabled = index === photos.length - 1;
      }
      function useImageBackup(failed) {
        if (!(failed instanceof HTMLImageElement)) return;
        const backup = failed.getAttribute('data-mr-image-backup')?.trim();
        if (!backup || failed.dataset.mrBackupUsed) return;
        failed.dataset.mrBackupUsed = 'true';
        failed.removeAttribute('srcset');
        failed.src = backup;
      }
      root.addEventListener('error', event => useImageBackup(event.target), {...options, capture:true});
      root.querySelectorAll('img[data-mr-image-backup]').forEach(photo => {
        if (photo.complete && !photo.naturalWidth) useImageBackup(photo);
      });
      root.addEventListener('click', event => {
        const link = event.target.closest('a[data-interview-photo]');
        if (!link || event.defaultPrevented || event.button !== 0 || event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) return;
        event.preventDefault();
        photos = [...root.querySelectorAll('a[data-interview-photo]')].filter(photo => photo.getClientRects().length > 0);
        restoreFocus = link;
        previousOverflow = document.body.style.overflow;
        show(photos.indexOf(link));
        dialog.showModal();
        document.body.style.overflow = 'hidden';
        close.focus({preventScroll:true});
      }, options);
      close.addEventListener('click', () => dialog.close(), options);
      previous.addEventListener('click', () => show(index - 1), options);
      next.addEventListener('click', () => show(index + 1), options);
      dialog.addEventListener('click', event => {
        if (event.target === dialog || event.target === dialog.querySelector('figure')) dialog.close();
      }, options);
      dialog.addEventListener('keydown', event => {
        if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') {
          event.preventDefault();
          show(index + (event.key === 'ArrowRight' ? 1 : -1));
        } else if (event.key === 'Escape') {
          event.preventDefault();
          dialog.close();
        }
      }, options);
      dialog.addEventListener('close', () => {
        document.body.style.overflow = previousOverflow;
        image.removeAttribute('src');
        image.removeAttribute('data-mr-image-backup');
        restoreFocus?.focus({preventScroll:true});
      }, options);
      controllers.set(root, {destroy() {
        if (dialog.open) {document.body.style.overflow = previousOverflow; dialog.close();}
        events.abort(); controllers.delete(root);
      }});
    });
  }
  init(document);
  document.addEventListener('shopify:section:load', event => init(event.target));
  document.addEventListener('shopify:section:unload', event => {
    event.target.querySelectorAll('[data-mr-interview]').forEach(root => controllers.get(root)?.destroy());
  });
})();
